// eslint-disable-next-line import/prefer-default-export
export const excerpt = (s, length) => `${s.replace(new RegExp(`^(.{${length}}[^\\s]*).*`), '$1')}…`;

export const getYearsLabel = years => {
  if (years === 1) {
    return '1 year';
  }
  return `${years} years`;
};
